import { render, staticRenderFns } from "./DefBar.vue?vue&type=template&id=00f4bb1e&scoped=true&"
import script from "./DefBar.vue?vue&type=script&lang=js&"
export * from "./DefBar.vue?vue&type=script&lang=js&"
import style0 from "./DefBar.vue?vue&type=style&index=0&id=00f4bb1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f4bb1e",
  null
  
)

export default component.exports